export default "__VITE_ASSET__CqpOb8V9__"